import { Component, OnInit } from '@angular/core';
import {AngularFirestoreCollection, AngularFirestoreDocument, AngularFirestore} from '@angular/fire/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClient , HttpHeaders } from '@angular/common/http';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  details:any="";
  AllUsers: number;
  EnovelChapters: number;
  Ecomicepisode: number;
  Ecomicseasons: number;
  Enovelseasons: number;
  feedbacks: number;
  PremiumCollections: any=[];
  TotalSales: number;
  constructor(private afs: AngularFirestore, private http: HttpClient) {
  }

  ngOnInit() {
    this.getDashBoard()
    // let header:any = new HttpHeaders();
    // header = header.set("Access-Control-Allow-Origin", "*");
    // header = header.set("Access-Control-Allow-Methods", "GET,PUT,POST,DELETE,PATCH,OPTIONS");
    // this.http.post('https://us-central1-webnnel-nextontop.cloudfunctions.net/getdetails', {},header).subscribe(data => {
    // console.log(data);
    // this.details  = data;
    // console.log(this.details)
    // }, error => {
    //   this.details  = "";
    //   console.log(error);
    // });
  }
  async getDashBoard(){
    
    const usersCollection = this.afs.collection("users"); // collection of users
    await usersCollection.valueChanges().subscribe((resp)=>{
      console.log(resp.length)
      this.AllUsers = resp.length;
    });
    const Enovelchapter = this.afs.collection("Enovelchapter"); // collection of users
    await Enovelchapter.valueChanges().subscribe((resp)=>{
      console.log(resp.length)
      this.EnovelChapters = resp.length;
    });
    const Ecomicepisode = this.afs.collection("Ecomicepisode"); // collection of users
    await Ecomicepisode.valueChanges().subscribe((resp)=>{
      console.log(resp.length)
      this.Ecomicepisode = resp.length;
    });
    const Ecomicseason = this.afs.collection("Ecomicseason"); // collection of users
    await Ecomicseason.valueChanges().subscribe((resp)=>{
      console.log(resp.length)
      this.Ecomicseasons = resp.length;
    });
    
    const Enovelseason = this.afs.collection("Enovelseason"); // collection of users
    await Enovelseason.valueChanges().subscribe((resp)=>{
      console.log(resp.length)
      this.Enovelseasons = resp.length;
    });
    const feedback = this.afs.collection("feedbacks"); // collection of users
    await feedback.valueChanges().subscribe((resp)=>{
      console.log(resp.length)
      this.feedbacks = resp.length;
    });
    
    const PremiumCollection = this.afs.collection("PremiumCollection"); // collection of users
    await PremiumCollection.valueChanges().subscribe((resp)=>{
      console.log(resp.length)
      this.PremiumCollections = resp;
      this.TotalSales = this.getTotal.total
    });
    

  }
  
  get getTotal() {
    let total = 0;
    this.PremiumCollections.forEach((ele) => {
            total += parseFloat(ele.price);
    });
    return {
        total
    };
}

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts